import { useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import cookie from "js-cookie";
import { renewTokenUser } from "../../redux/features/auth/authSlice";
import { GlobalStateContext } from "../context/GlobalStateContext";

const HOC = (WrappedComponent, type = "required-auth") => {
  const Wrapper = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { isLogin } = useContext(GlobalStateContext);

    const renewToken = cookie.get("renewToken");
    const accessToken = cookie.get("accessToken");
    const role = localStorage.getItem("role");

    useEffect(() => {
      if (!accessToken && renewToken) {
        dispatch(renewTokenUser());
      }
    }, [accessToken, renewToken, dispatch]);

    useEffect(() => {
      const isAuthenticated = !!(accessToken || renewToken || isLogin);
      const isDoctor = role === "2";
      const isCustomer = role === "1";

      // Halaman auth (login, register, dll) — user sudah login tidak boleh akses
      // Redirect ke home sesuai role
      if (type === "guest-only" || type === "login-required" || type === "Register-required") {
        if (isAuthenticated) {
          navigate(isDoctor ? "/doctor-dashboard" : "/purchase", { replace: true });
        }
        return;
      }

      // Halaman yang wajib login (customer & dokter boleh)
      if (type === "required-auth") {
        if (!isAuthenticated) {
          navigate("/profile", {
            state: { from: location.pathname, message: "Silakan login terlebih dahulu" },
            replace: true,
          });
        }
        return;
      }

      // Halaman khusus dokter — guest & customer tidak boleh
      if (type === "doctor-required") {
        if (!isAuthenticated) {
          navigate("/profile", {
            state: { from: location.pathname, message: "Silakan login terlebih dahulu" },
            replace: true,
          });
          return;
        }
        if (!isDoctor) {
          navigate("/purchase", { replace: true });
        }
        return;
      }

      // Halaman khusus customer (wajib login, dokter tidak boleh)
      if (type === "customer-required") {
        if (!isAuthenticated) {
          navigate("/profile", {
            state: { from: location.pathname, message: "Silakan login terlebih dahulu" },
            replace: true,
          });
          return;
        }
        if (!isCustomer) {
          navigate("/doctor-dashboard", { replace: true });
        }
        return;
      }

      // Halaman publik — siapa saja boleh kecuali dokter yang sudah login
      if (type === "no-doctor") {
        if (isAuthenticated && isDoctor) {
          navigate("/doctor-dashboard", { replace: true });
        }
        return;
      }

    }, [accessToken, renewToken, isLogin, role, location.pathname]);

    return <WrappedComponent {...props} />;
  };

  return Wrapper;
};

export default HOC;